import React, { Component } from "react";
import { Form, Input, Table, Modal, Radio } from "antd";
import Api from "../../../services/ServiceApi";
import Cookies from "js-cookie";
import ServiceCheckList from "./service_check_list";
const columns = [
  {
    title: "Service Type ID",
    render: (item) =>
      !item.service_type_level_id ? (
        "-"
      ) : (
        <a
          href="/MaxiOperation/full_detail_job"
          className="c-blue text-underline"
        >
          {item.service_type_level_id}
        </a>
      ),
    align: "center",
    key: "service_type_id",
    sorter: (a, b) => b.service_type_level_id - a.service_type_level_id,
  },
  {
    title: "Service Type Name",
    render: (item) => (!item.service_desc ? "-" : item.service_desc),
    align: "center",
    key: "service_desc",
    sorter: (a, b) => a.service_desc.length - b.service_desc.length,
  },
  {
    title: "Operators",
    render: (item) => (!item.operator_id ? "-" : item.operator_id),
    align: "center",
    key: "operator_id",
    sorter: (a, b) => a.operator_id.length - b.operator_id.length,
  },
  {
    title: "Created by",
    render: (item) => (!item.emp_code ? "-" : item.emp_code),
    align: "center",
    key: "emp_code",
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (item) => {
      return (
        <div>
          {item === 0 ? (
            <span></span>
          ) : (
            <span className="c-green">
              <span className="dot-active mr-2"></span>Active
            </span>
          )}
        </div>
      );
    },
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    render: (item) => (
      <div>
        {/* <a href="/MaxiOperation/edit_job"> */}
          <img src={Api.absoluteUrl("/icon/edit.svg")} />
        {/* </a> */}
        {/* <a href="/MaxiOperation/edit_job"> */}
          <img src={Api.absoluteUrl("/icon/delete.svg")} />
        {/* </a> */}
      </div>
    ),
  },
];

class ServiceType extends Component {
  serviceForm = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: 0,
      menu: [
        { icon: "ma_list.svg", title: "MA List", link: "" },
        {
          icon: "ma_team_service.svg",
          title: "MA Team Service",
          link: "/ma_team_service",
        },
        { icon: "", title: "Material Stock", link: "/material_stock" },
        {
          icon: "notifications.svg",
          title: "Notifications",
          link: "/notifications",
        },
        { icon: "report.svg", title: "Report", link: "/report" },
        { icon: "", title: "Setting", link: "/setting" },
      ],
      data: [
        // {
        //   key: "1",
        //   service_type_id: 123234235,
        //   service_type_name: "Digital_HD_Pano",
        //   operators: "Static",
        //   created_by: "chanakarn_r",
        //   status: 1,
        // },
        // {
        //   key: "2",
        //   service_type_id: 123234236,
        //   service_type_name: "Samsung",
        //   operators: "Digital",
        //   created_by: "chanakarn_r",
        //   status: 1,
        // },
        // {
        //   key: "3",
        //   service_type_id: 123234237,
        //   service_type_name: "Panasonic",
        //   operators: "Static",
        //   created_by: "chanakarn_r",
        //   status: 1,
        // },
      ],
      // when able to call api
      realData: [],
      visible: false,
      isCheckListVisible: false,
      value: 1,
    };
  }
  handleCheckListVisible(visible) {
    this.setState({ isCheckListVisible: visible });
  }

  async componentDidMount() {
    const serviceData = await Api.post("get_service_type_ma", {
      company_id: "1",
      operator_id: Cookies.get("operator_id"),
      job_category_id: "",
      job_type_id: "",
      service_type_level_id: "",
    });
    console.log("servicedata", serviceData);
    this.setState({ data: [...serviceData.data.data.result] });
  }

  handleSubmit(values) {
    console.log("Success:", values);
  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
  };

  onModal(visible) {
    // this.setState({ visible: visible });
    this.setState({ isCheckListVisible: visible });
  }

  renderAdd() {
    const { visible, value } = this.state;
    return (
      <Modal
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Add Group Type
          </span>
        }
        centered
        visible={visible}
        footer={null}
        closable={false}
        className="custom-modal"
      >
        <div className="d-flex align-items-center">
          <div className="mr-4">
            <span className="font-thai-r fs-18">Status</span>
          </div>
          <Radio.Group onChange={this.onChange} value={value}>
            <Radio value={1}>
              <span className="font-thai-r fs-18">Active</span>
            </Radio>
            <Radio value={2}>
              <span className="font-thai-r fs-18">Inactive</span>
            </Radio>
          </Radio.Group>
        </div>

        <Form
          onFinish={(values) => this.handleSubmit(values)}
          layout="vertical"
          ref={this.serviceForm}
        >
          <div className="row">
            {/* <div className="col">
              <Form.Item
                name="brand_id"
                label="Brand ID"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div> */}
            <div className="col">
              <Form.Item
                name="brand_name"
                label="Brand Name"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="model_name"
                label="Model Name"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Form.Item
                name="serial_no"
                label="S/N"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="asset_type"
                label="Asset Type"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="asset_sub_type"
                label="Asset Sub Type"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Form.Item
                name="format"
                label="Format"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="resolution"
                label="Resolution"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="airing_time"
                label="Airing Time"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <Form.Item
                name="eyeball_month"
                label="Eyeball / Month"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
            <div className="col-8">
              <div className="row">
                <div className="col">
                  <Form.Item
                    name="sqm"
                    label="Sqm"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div>
                <div className="col">
                  <Form.Item
                    name="screen_size_inch"
                    label="Screen Size (Inch)"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div>
                <div className="col">
                  <Form.Item
                    name="width"
                    label="Width"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div>
                <div className="col">
                  <Form.Item
                    name="length"
                    label="Length"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>

          <Form.Item className="mb-0 text-center">
            <button
              type="reset"
              onClick={() => this.onModal(false)}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button className="btn btn-success" type="submit">Add</button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  render() {
    const { data, isCheckListVisible } = this.state;
    return (
      <div>
        {isCheckListVisible ? (
          <ServiceCheckList
            handleVisible={this.handleCheckListVisible.bind(this)}
          />
        ) : (
          <div>
            <span className="font-mont-r fs-12">Basic Data</span>
            <h3 className="font-mont-sb fs-18 c-blue">Service Type</h3>

            <div className="d-flex justify-content-between my-3">
              <Input.Search
                placeholder="Search"
                onSearch={(value) => console.log(value)}
                style={{ width: 200 }}
              />

              <button
                className="btn btn-warning"
                onClick={() => this.onModal(true)}
              >
                <img src={Api.absoluteUrl("/icon/plus.svg")} className="mr-2" />
                Service Type
              </button>
            </div>

            {this.renderAdd()}
            <Table columns={columns} dataSource={data} pagination={true} />
          </div>
        )}
      </div>
    );
  }
}
export default ServiceType;
